import { Theme } from '@mui/material';

export const chipSx = {
  height: '1.75rem',
  px: 1.25,
  gap: 0.5,
  flexShrink: 0,
  borderRadius: '9999px',
  border: '1px solid',
  fontSize: '0.8rem',
  lineHeight: 1.4,
  transition: 'background-color 150ms, border-color 150ms, color 150ms',
  '@media (hover: none)': {
    height: '2.25rem',
    px: 1.5,
    fontSize: '0.875rem',
  },
  '&.Mui-focusVisible': {
    outline: (theme: Theme) => `2px solid ${theme.palette.text.link}`,
    outlineOffset: '2px',
  },
} as const;

export const restingChipSx = {
  borderColor: 'background.divider',
  backgroundColor: 'common.white',
  color: 'text.secondary',
  '@media (hover: hover)': {
    '&:hover': {
      backgroundColor: 'highlight.neutral',
      color: 'text.primary',
    },
  },
} as const;

export const selectedChipSx = {
  borderColor: 'text.link',
  backgroundColor: 'text.linkLight',
  color: 'text.linkDark',
} as const;
